import request from './request'
import { COVER_WRITE_URL, WORK_TASK_QUERY_URL } from './config'

export function createCover (payload) {
  return request.post(COVER_WRITE_URL, payload)
}

export function queryWorkTask (taskId) {
  return request.post(WORK_TASK_QUERY_URL, { taskId })
}

